import { Component, inject } from '@angular/core';
import { ModalRef, ModalModule, ButtonV2Module } from '@schenck/rotec-components';
import { MODAL_WIDTH } from '../../../../src/utils/constants/modal.const';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';

@Component({
  selector: 'duplicate-method.component',
  templateUrl: './duplicate-method.component.html',
  styleUrls: ['./duplicate-method.component.less'],
  imports: [ModalModule, TranslatePipe, TranslateDirective, ButtonV2Module],
})
export class DuplicateMethodModalComponent {
  public modalRef = inject<ModalRef<'left' | 'right'>>(ModalRef);

  public width = MODAL_WIDTH;
  public summary = 'Copy Settings';
  public sideFromText: 'Plane 1' | 'Plane 2';
  public sideToText: 'Plane 1' | 'Plane 2';

  constructor() {
    const modalRef = this.modalRef;

    if (modalRef.data === 'left') {
      this.sideFromText = 'Plane 1';
      this.sideToText = 'Plane 2';
    } else {
      this.sideFromText = 'Plane 2';
      this.sideToText = 'Plane 1';
    }
  }

  public cancel(): void {
    this.modalRef.close();
  }

  public confirm(): void {
    this.modalRef.emitAndClose(true);
  }
}
